<template>
  <div>
    <div class="cerchio d-flex align-items-center justify-content-center">
      <imageLoader class="fa-2x"   :imgInfo="trItem"></imageLoader> 
    </div>
  </div>
</template>

<script>
import { EventBus } from "../main.js";
import { db } from "@/components/Firebase_Conn";
import { ref } from "@/components/puntatori";

export default {
  name: "crudTableMagazzinoImmagine",
  props: ["trItem"],
  directives: {},
  data() {
    return {
      //VARIABILI AMBIENTE
    };
  },
  computed: {},
  methods: {
    getImageUrl(oggetto) {
      let estensione = oggetto.img_name.substr(oggetto.img_name.length - 4, 4);
      let img_name = oggetto.img_name.substr(0, oggetto.img_name.length - 4);
      if (oggetto.img_name !== null)
        if (oggetto.fonte === "interno" && estensione === ".ext")
          return (
            ref.urlBucketEsterno +
            oggetto.parent +
            "%2F" +
            img_name +
            "?alt=media"
          );
      if (oggetto.fonte === "interno")
        return (
          ref.urlBucket +
          oggetto.parent +
          "%2F" +
          oggetto.img_name +
          "?alt=media"
        );
      if (oggetto.fonte === "esterno")
        return (
          ref.urlBucketEsterno +
          oggetto.parent +
          "%2F" +
          oggetto.img_name +
          "?alt=media"
        );
    }
  },
  mounted() {},
  watch: {}
};
</script>

<style scoped>
.cerchio {
  background-color: white;
  border-radius: 50%;
  height: 8vh;
  width: 8vh;
  overflow: hidden;
}

.cerchio img {
  max-width: 110%;
  max-height: 110%;
}
</style>
